module.exports = __webpack_public_path__ + "static/media/medasrdemo-Paul.59e58668.mp4";